var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatargroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 60,
    viewBox: "0 0 124 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 9.25,
    width: 49.5,
    height: 49.5,
    rx: 24.75,
    fill: "#AA9C75"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 9.25,
    width: 49.5,
    height: 49.5,
    rx: 24.75,
    stroke: "white",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.25,
    y: 9.25,
    width: 49.5,
    height: 49.5,
    rx: 24.75,
    fill: "#D4B5AD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.25,
    y: 9.25,
    width: 49.5,
    height: 49.5,
    rx: 24.75,
    stroke: "white",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.25,
    y: 1.25,
    width: 57.5,
    height: 57.5,
    rx: 28.75,
    fill: "#C7B9DA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.25,
    y: 1.25,
    width: 57.5,
    height: 57.5,
    rx: 28.75,
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatargroup);
export default __webpack_public_path__ + "static/media/Avatar group.352e98516910f74de055adc421798beb.svg";
export { ForwardRef as ReactComponent };